// Production'da console.log'ları gizlemek için utility
export const logger = {
  error: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(message, ...args);
    }
  },
  log: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(message, ...args);
    }
  },
  warn: (message, ...args) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(message, ...args);
    }
  },
  // Güvenli error mesajları için
  secureError: (userMessage, technicalError) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('Technical Error:', technicalError);
    }
    return userMessage;
  }
};
